import React from "react";
import { Check, AlertOctagon, Circle } from "lucide-react";
import { journeyFor, currentStep, isDisputed, STEPS } from "@/lib/orderJourney";

/**
 * Role-aware lifecycle stepper. Horizontal on ≥768px, vertical on mobile.
 * Disputed orders render with a red current dot.
 */
export default function OrderTimeline({ order, role }) {
  const journey = journeyFor(role);
  const idx = currentStep(order);
  const disputed = isDisputed(order);

  return (
    <div className="order-timeline" data-testid="order-timeline">
      <ol className="ot-list">
        {journey.map((step, i) => {
          const done = i < idx;
          const current = i === idx;
          const future = i > idx;
          return (
            <li key={step.id} className={"ot-step " + (done ? "ot-done" : current ? "ot-current" : "ot-future") + (disputed && current ? " ot-disputed" : "")}
                data-testid={`ot-step-${step.key}`}>
              <span className="ot-dot" aria-hidden>
                {disputed && current ? <AlertOctagon size={12} />
                  : done ? <Check size={12} />
                  : current ? <span className="ot-dot-pulse" />
                  : <Circle size={8} />}
              </span>
              <div className="ot-body">
                <div className="ot-title">{step.title}</div>
                {current && <div className="ot-subtitle">{step.subtitle}</div>}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
